import { Box, Typography, Paper, Grid, FormControl, RadioGroup, FormControlLabel, Radio, Alert, TextField, FormHelperText } from "@mui/material";
import RequiredLabel from "components/RequiredLabel";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

export default function Languages() {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Box>
      <Paper sx={{ p: 2 }}>
        <Alert variant="outlined" severity="warning">
          {t("The home language survey is used solely to offer appropriate educational services. This survey is the first of three steps to identify whether or not a student is eligible to be identified as an English language learner (ELL). 'Home' is defined as a student's current place of residence.")}
        </Alert>
      </Paper>
      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, mt: 1 }}>
        <Box backgroundColor="divider" sx={{ p: 2, borderTopLeftRadius: 8, borderTopRightRadius: 8, }}>
          <Typography variant="h6">
            {t("Home Language Survey")}
          </Typography>
        </Box>
        <Grid container spacing={2} pt={1}>

          <Grid item xs={12} md={12}>
            <Controller
              name="languagesAtHome"
              control={control}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  label={<RequiredLabel>{t("List all languages used in the student's home.")}</RequiredLabel>}
                  fullWidth
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                />
              )}
            />
          </Grid>

          <Grid item xs={12} sx={{ mx: 1 }}>
            <FormControl component="fieldset">
              <Typography sx={{ mb: 1 }}><RequiredLabel>{t("Was the first language used by the student a language other than English?")}</RequiredLabel></Typography>
              <Controller
                name="surveryQuestion1"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <RadioGroup
                      row {...field}>
                      <FormControlLabel value="yes" control={<Radio />} label={t("Yes")} />
                      <FormControlLabel value="no" control={<Radio />} label={t("No")} />
                    </RadioGroup>
                    {fieldState.error && (
                      <FormHelperText sx={{ color: 'error.main' }}>{fieldState.error.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sx={{ mx: 1 }}>
            <FormControl component="fieldset">
              <Typography sx={{ mb: 1 }}><RequiredLabel>{t("Does the student speak or understand a language other than English?")}</RequiredLabel></Typography>
              <Controller
                name="surveryQuestion2"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <RadioGroup row {...field}>
                      <FormControlLabel value="yes" control={<Radio />} label={t("Yes")} />
                      <FormControlLabel value="no" control={<Radio />} label={t("No")} />
                    </RadioGroup>
                    {fieldState.error && (
                      <FormHelperText sx={{ color: 'error.main' }}>{fieldState.error.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sx={{ mx: 1 }}>
            <FormControl component="fieldset">
              <Typography sx={{ mb: 1 }}><RequiredLabel>{t("When interacting with others at home (example: parents, guardians, siblings), does the student understand or use a language other than English most of the time?")}</RequiredLabel></Typography>
              <Controller
                name="surveryQuestion3"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <RadioGroup row {...field}>
                      <FormControlLabel value="yes" control={<Radio />} label={t("Yes")} />
                      <FormControlLabel value="no" control={<Radio />} label={t("No")} />
                    </RadioGroup>
                    {fieldState.error && (
                      <FormHelperText sx={{ color: 'error.main' }}>{fieldState.error.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sx={{ mx: 1 }}>
            <FormControl component="fieldset">
              <Typography sx={{ mb: 1 }}><RequiredLabel>{t("When interacting with others outside the home (example: friends, caregivers), does the student understand or use a language other than English most of the time?")}</RequiredLabel></Typography>
              <Controller
                name="surveryQuestion4"
                control={control}
                render={({ field, fieldState }) => (
                  <>
                    <RadioGroup row {...field}>
                      <FormControlLabel value="yes" control={<Radio />} label={t("Yes")} />
                      <FormControlLabel value="no" control={<Radio />} label={t("No")} />
                    </RadioGroup>
                    {fieldState.error && (
                      <FormHelperText sx={{ color: 'error.main' }}>{fieldState.error.message}</FormHelperText>
                    )}
                  </>
                )}
              />
            </FormControl>
          </Grid>

        </Grid>
      </Paper>
    </Box>
  );
}
